import { Alert, Button, Input, Tooltip } from 'antd';
import React, { useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { message, Upload, Typography } from 'antd';
const { Dragger } = Upload;
const { Paragraph, Text } = Typography;
import classes from './CredForm.module.css';
import { connect } from 'dva';
import GCPSvgIcon from '@/../public/gcp-logo.svg';
import { getSignedUrl } from '@/utils/utils';

const BasicInfoStepsByShell = ({ gcpSignedURL, loadingSignedUrl, dispatch, props }) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const handleFileChange = info => {
    const { file, fileList } = info;

    if (file.status === 'done') {
      message.success(`${file.name} file uploaded successfully.`);
      // Handle file upload success, possibly inform parent component
    } else if (file.status === 'error') {
      message.error(`${file.name} file upload failed.`);
      // Handle file upload failure, possibly inform parent component
    }

    // Check if a file was removed from the list
    if (
      fileList.length === 0 ||
      fileList.find(f => f.uid === file.uid && file.status === 'removed')
    ) {
      // File has been removed, perform necessary state update or inform parent
      onFormValuesChange('service_account', null); // Example: reset the related form value
    }
  };

  const handleBeforeUpload = file => {
    const reader = new FileReader();
    reader.onload = e => {
      // Here you can access the file content
      const content = e.target.result;
      // If you need to parse JSON, you can do it here
      try {
        onFormValuesChange('service_account', content);
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    };
    reader.readAsText(file);

    return false;
  };

  const onFormValuesChange = (field, value) => {
    props.sentRequireData.providerCallback('authMethodDataGCP', {
      [field]: value,
    });
  };
  const validateForm = () => {
    return props.form.validateFields(['service_account'], (err, values) => {
      if (!err) {
        // this.props.form.resetFields();
      }
    });
  };

  const signedUrlCommand = `wget "${gcpSignedURL}" -O basic-onboarding.zip`;

  return (
    <>
      <div className={(classes.flexColumn, classes.cardMain)}>
        <div
          style={{
            display: 'flex',
            // gap: '4rem',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '10px',
            }}
          >
            <Alert
              message="Ensure that your IAM user has at least the Editor role in order to perform the onboarding steps smoothly."
              type="info"
              showIcon
              style={{ marginBottom: '30px' }}
            />
            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>1</div>
                </div>
              </div>
              <div style={{ display: 'inline', marginTop: '-5px', marginBottom: '12px' }}>
                <p>
                  <b>Access GCP Console and Open Cloud Shell:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    <p style={{ display: 'inline', margin: '0' }}>
                      Log in to Google Cloud Console by clicking
                    </p>
                    <a
                      href="https://console.cloud.google.com/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    >
                      &nbsp;<u>here</u>&nbsp;
                    </a>
                    <p style={{ display: 'inline', margin: '0' }}>
                      and select the project you want to connect to Cloudnosys.
                    </p>
                  </li>

                  <li>
                    Click the “Activate Cloud Shell” button in the top-right corner to open the
                    terminal.
                  </li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>2</div>
                </div>
              </div>
              <div id="myForm">
                <p>
                  <b>Download the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>Copy the SignedURL from the Cloudnosys portal.</li>
                  <li>In the Cloud Shell, run this command to download the onboarding script:</li>
                </ul>
                <div
                  style={{
                    display: 'flex',
                    gap: '1.7rem',
                  }}
                >
                  {gcpSignedURL.length ? (
                    <Paragraph
                      copyable={{ text: signedUrlCommand }}
                      className={classes.paragraphStyle}
                    >
                      {signedUrlCommand}
                    </Paragraph>
                  ) : (
                    <Paragraph className={classes.paragraphStyle}>
                      Click on the Generate Signed Url Button
                    </Paragraph>
                  )}
                  <Tooltip title="The Signed URL will be valid for 15 min Only">
                    <Button
                      style={{ backgroundColor: 'transparent', color: '#252525A6' }}
                      onClick={() => getSignedUrl('basic', 'gcp', dispatch, setIsDisabled)}
                      size="large"
                      disabled={isDisabled}
                      loading={loadingSignedUrl}
                    >
                      <img
                        src={GCPSvgIcon}
                        alt="Aws logo here"
                        style={{ marginRight: '10px', height: '1rem', width: '2rem' }}
                      />
                      Generate Signed URL
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>3</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Unzip and Run the Script:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Run the following combined command to unzip the file, make the script
                    executable, and then execute the script:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  unzip basic-onboarding.zip && chmod +x basic-onboarding.sh &&
                  ./basic-onboarding.sh
                </Paragraph>
                <p>
                  <b>NOTE:</b>&nbsp;This will create a service account with least privileged access
                  and the service account key required to complete onboarding for Basic protection
                  level.
                </p>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>4</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Download the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    In the Cloud Shell, type the following to verify the key file was created:
                  </li>
                </ul>
                <Paragraph copyable className={classes.paragraphStyle}>
                  ls ~/cloudnosys-sa-*.json
                </Paragraph>
                <ul className={classes.listStyle}>
                  <li>
                    Click the three-dotted “More” menu in the top-right corner of Cloud Shell and
                    select “<b>Download File</b>”.
                  </li>
                  <li>Locate and download the cloudnosys-sa-*.json file to your local machine.</li>
                </ul>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>5</div>
                </div>
              </div>
              <div>
                <p>
                  <b>Upload the Key:</b>
                </p>
                <ul className={classes.listStyle}>
                  <li>
                    Drag and drop, or browse to upload the downloaded JSON key file into the box
                    below.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* <div>
            <video controls width="400px" className={classes.videoStyle}>
              <source
                src="https://firebasestorage.googleapis.com/v0/b/temp-cloudnosys.appspot.com/o/gcpaddaccount.mp4?alt=media&token=beedbc8e-f27e-4451-8fa3-18a1c6cc5c25"
                type="video/mp4"
              />
            </video>
          </div> */}
        </div>
        <Dragger
          name="file"
          multiple={false}
          beforeUpload={handleBeforeUpload}
          onChange={handleFileChange}
          // showUploadList={false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Now browse the key or drag and drop in the box below</p>
        </Dragger>
      </div>
      <h5 className={classes.stepsHeading}>
        <span>Enable APIs</span>
      </h5>
      <div className={(classes.flexColumn, classes.cardMain)}>
        <div
          style={{
            display: 'flex',
            // gap: '4rem',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '10px',
            }}
          >
            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>1</div>
                </div>
              </div>
              <div>
                <p>
                  Make sure that you have selected the correct GCP project that you would like to
                  connect with Cloudnosys
                </p>
              </div>
            </div>

            <div className={classes.stepsContent}>
              <div>
                <div className={classes.index}>
                  <div>2</div>
                </div>
              </div>
              <div>
                <p>
                  Open the Google Command Line Interface (CloudShell) and enable the required APIs
                  using the following command:
                </p>

                <Paragraph copyable className={classes.paragraphStyle}>
                  gcloud services enable cloudapis.googleapis.com cloudasset.googleapis.com
                  compute.googleapis.com storage.googleapis.com iam.googleapis.com
                  iamcredentials.googleapis.com containerfilesystem.googleapis.com
                  containerregistry.googleapis.com container.googleapis.com logging.googleapis.com
                  monitoring.googleapis.com cloudresourcemanager.googleapis.com
                  cloudkms.googleapis.com dns.googleapis.com
                </Paragraph>
              </div>
            </div>
          </div>
          {/* <div>
            <video controls width="400px" className={classes.videoStyle}>
              <source
                src="https://firebasestorage.googleapis.com/v0/b/temp-cloudnosys.appspot.com/o/gcpaddaccount.mp4?alt=media&token=beedbc8e-f27e-4451-8fa3-18a1c6cc5c25"
                type="video/mp4"
              />
            </video>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default connect(({ cloudAccount }) => ({
  gcpSignedURL: cloudAccount.gcpSignedURL,
  loadingSignedUrl: cloudAccount.loadingSignedUrl,
}))(BasicInfoStepsByShell);
